var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bh-section',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"d-flex justify-center",attrs:{"cols":"6"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }